function asObject(payload) {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return {};
  }

  if (payload.data && typeof payload.data === 'object' && !Array.isArray(payload.data)) {
    return payload.data;
  }

  return payload;
}

function pickNumber(source, keys) {
  for (const key of keys) {
    const value = source?.[key];
    const numeric = Number(value);
    if (Number.isFinite(numeric)) {
      return numeric;
    }
  }

  return 0;
}

export function mapProfileStatsResponseToDto(payload) {
  const source = asObject(payload);

  return {
    profilesTotal: pickNumber(source, ['profilesTotal']),
    profilesVerificationTotal: pickNumber(source, ['profilesVerificationTotal']),
    accountsLiveTotal: pickNumber(source, ['accountsLiveTotal']),
    accountsDemoTotal: pickNumber(source, ['accountsDemoTotal']),
    documentsTotal: pickNumber(source, ['documentsTotal']),
    documentsNewTotal: pickNumber(source, ['documentsNewTotal']),
    processedDepositsTotal: pickNumber(source, ['processedDepositsTotal']),
    processedWithdrawalsTotal: pickNumber(source, ['processedWithdrawalsTotal']),
  };
}
